import React, { useState } from 'react';
import { toast } from 'react-toastify';
import {
  Container,
  Grid,
  Col,
  Panel,
  Form,
  Button,
  ButtonToolbar,
  Schema,
  Loader,
} from 'rsuite';
import api from '~/services/api';
import history from '~/services/history';

const { StringType } = Schema.Types;

const model = Schema.Model({
  email: StringType().isEmail('Email inválido').isRequired('Campo obrigatório'),
});

export default function EsqueciSenha() {
  const [email, setEmail] = useState('');
  const [enviando, setEnviando] = useState(false);

  async function pedirLink() {
    setEnviando(true);
    try {
      const resposta = await api.post('recuperar-senha/administrador', { email });
      toast.success(resposta.data.message);
      history.push('/');
    } catch (e) {
      toast.error(e.message);
    }
    setEnviando(false);
  }

  return (
    <div className="show-fake-browser login-page">
      <Container>
        <Grid>
          <Col mdOffset={6} md={12}>
            <Panel header={<h3>Esqueci minha senha</h3>} bordered>
              <Form
                fluid
                model={model}
                formValue={{ email }}
                onChange={(valor) => setEmail(valor.email || '')}
                onSubmit={(semErro) => semErro && pedirLink()}
              >
                <Form.Group>
                  <Form.ControlLabel>Email</Form.ControlLabel>
                  <Form.Control name="email" type="email" autoComplete="email" />
                </Form.Group>
                <p style={{ marginBottom: 16 }}>
                  Se o e-mail estiver cadastrado, você recebe um link válido por
                  20 minutos. Ele só pode ser usado uma vez.
                </p>
                <ButtonToolbar>
                  <Button appearance="primary" type="submit" block disabled={enviando}>
                    Enviar link
                  </Button>
                  <Button
                    appearance="link"
                    type="button"
                    block
                    onClick={() => history.push('/')}
                  >
                    Voltar ao login
                  </Button>
                </ButtonToolbar>
                {enviando && <Loader backdrop content="loading..." vertical />}
              </Form>
            </Panel>
          </Col>
        </Grid>
      </Container>
    </div>
  );
}
